<template>
  <b-row>
    <b-col cols="10">
      <b-row>
        <b-col cols="8">
          <b-form-group>
              <label :for="`number-${id}`"><i class="fa fa-arrow-right"></i> Forward Number</label>
              <b-form-input size="sm" type="text" :id="`number-${id}`" v-model="number"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <label :for="`duration-${id}`">Duration</label>
          <b-form-input size="sm" type="text" :id="`duration-${id}`" v-model="duration"></b-form-input>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="2" class="text-right">
      <b-btn-group>
        <b-btn size="sm" v-if="dirty" @click="save()" variant="success"><i class="fa fa-check"></i></b-btn>
        <b-btn size="sm" variant="danger" @click="del()"><i class="fa fa-trash"></i></b-btn>
      </b-btn-group>
    </b-col>
  </b-row>
</template>
<script>

export default {
  name: 'Endpoint',
  props: [ 'index', 'value' ],
  computed: {
    dirty () {
      let number = this.number.toString().replace(/\D/g, '')
      if (number.length === 10 && number[0] != '1') number = `1${number}`
      if (number.length === 11 && (this.value.actionId != number || this.value.duration != this.duration)) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      id: null,
      number: null,
      duration: null
    }
  },
  created () {
    this.id = this.value.id
    this.number = this.value.actionId
    this.duration = this.value.duration
  },
  methods: {
    async save () {
      const id = this.value.id
      let number = this.number.toString().replace(/\D/g, '')
      if (number.length === 10 && number[0] != '1') number = `1${number}`

      const route = {
        numberId: this.value.numberId,
        actionType: this.value.actionType,
        actionId: number,
        duration: this.duration,
        useAccountCallerId: this.value.useAccountCallerId,
        sort: this.value.sort
      }

      if (id > 0) {
        route.id = this.value.id
        let { data } = await this.$axios.put(`/v1/numbers/routes/${id}`, route)
        this.$emit('update', 'save', this.index, data)
      } else {
        let { data } = await this.$axios.post(`/v1/numbers/routes`, route)
        this.$emit('update', 'save', this.index, data)
      }

    },
    async del () {
      const id = this.value.id || null
      if (id) {
        await this.$axios.delete(`/v1/numbers/routes/${id}`)
      }
      this.$emit('update', 'delete', this.index)
    }
  },
  watch: {
    value: {
      handler () {
        this.id = this.value.id
        this.number = this.value.actionId
        this.duration = this.value.duration
      }
    },
  }
}
</script>
